var map = {
	"./downloads-doc.svg": "6cb2",
	"./downloads-icon.svg": "6c51",
	"./downloads-pdf.svg": "7143",
	"./downloads-xls.svg": "1afc",
	"./downloads-zip.svg": "de6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8c4f6";